// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuTabs_container__35ZIi"};